export interface InviteInfoParams {
  page?: number
  page_size?: boolean
  many: boolean
  is_invitee?: number // 0=被邀人，1=邀请人
  invitation_read?: number // 邀请人是否已读，0=未读，1=已读
  accept_read?: string // 被请人是否已读，0=未读，1=已读
  goon_behavior_type?: any[]
  use_cache?: string
}

export interface InviteInfoItem {
  id: number
  accept_read: boolean // 被邀请人是否已读
  invitation_read: boolean // 邀请人是否已读
  accept_total_credit_coins: number // 被邀请人奖励
  goon_behavior_type: 1 | 2 | 3 // 1-完成注册 2-升级个人版月套餐 3-升级个人版年套餐
}

export interface ActivityItem {
  pc_web_page: {
    reward: {
      url: string
      color: string
    }
    landing: {
      url: string
      color: string
    }
  }
  mobile_web_page: {
    landing: {
      url: string
      color: string
    }
  }
}

export enum INVITE_RECORD_TYPE {
  REGISTER = 1, // 注册
  MONTH = 2, // 个人月套餐
  YEAR = 3, // 个人年套餐
}
